import React from 'react';

export default () => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="48"
    viewBox="0 0 48 48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <circle cx="24" cy="26" fill="#D4E9E2" r="22" />
      <path
        d="M6.143 8.545L4.205 8.38l-.442-1.894-.756 1.793-1.937-.165 1.471 1.272-.756 1.793 1.664-1.006 1.471 1.273-.442-1.894 1.665-1.006z"
        fill="#CBA258"
      />
      <path
        clipRule="evenodd"
        d="M7.298 9.771l3.333 2.97 3.804-1.975-1.71 4.04 2.956 3.235-4.35-.498-2.099 3.844-.943-4.28-4.287-.927 3.804-1.974-.508-4.435z"
        fill="#CBA258"
        fillRule="evenodd"
      />
      <path
        d="M8.18 4.975l.871.508-.975-.007-.165 1.011-.362-.944-.999.157.792-.647-.49-.845.874.506L8.441 4l-.262.975z"
        fill="#CBA258"
      />
      <mask
        height="44"
        id="a"
        maskUnits="userSpaceOnUse"
        width="44"
        x="2"
        y="4"
      >
        <circle cx="24" cy="26" fill="#D4E9E2" r="22" />
      </mask>
      <g mask="url(#a)">
        <path
          clipRule="evenodd"
          d="M24.718 6.941a4 4 0 00-5.438 1.56l-2.704 4.878c-.134.242-.201.363-.211.468a.443.443 0 00.05.27c.048.094.177.2.433.412a4.29 4.29 0 011.021 5.382 4.29 4.29 0 01-5.105 1.987c-.316-.105-.474-.158-.58-.148a.443.443 0 00-.254.1c-.085.063-.152.184-.286.426L8.94 27.154a4 4 0 001.56 5.438L38.275 47.99a4 4 0 005.437-1.56l10.34-18.653a4 4 0 00-1.559-5.438L24.718 6.941z"
          fill="#F9F9F9"
          fillRule="evenodd"
        />
        <rect
          fill="#DFC49D"
          height="2"
          rx=".5"
          transform="rotate(29 33.181 17)"
          width="29"
          x="33.181"
          y="17"
        />
        <rect
          fill="#DFC49D"
          height="2"
          rx=".5"
          transform="rotate(29 31.242 20.498)"
          width="23"
          x="31.242"
          y="20.498"
        />
        <rect
          fill="#DFC49D"
          height="2"
          rx=".5"
          transform="rotate(29 29.302 23.997)"
          width="23"
          x="29.302"
          y="23.997"
        />
        <rect
          fill="#00754A"
          height="4"
          rx="2"
          transform="rotate(29 24.94 31.869)"
          width="12"
          x="24.939"
          y="31.869"
        />
        <rect
          fill="#DFC49D"
          height="2"
          rx=".5"
          transform="rotate(29 27.363 27.495)"
          width="23"
          x="27.363"
          y="27.495"
        />
        <path
          clipRule="evenodd"
          d="M32.839 8.809a.25.25 0 01.322.382l-.004.003-.014.012a9.903 9.903 0 00-.277.249.25.25 0 11-.338-.37 14.4 14.4 0 01.289-.257l.016-.014.004-.004.002-.001zm-1.072 1.36a.25.25 0 01.005.354c-.175.18-.362.377-.561.593a.25.25 0 11-.367-.34c.201-.218.392-.418.569-.601a.25.25 0 01.354-.005zm-1.6 1.739a.25.25 0 01.027.352c-.17.2-.344.408-.522.625a.25.25 0 11-.387-.316c.18-.22.357-.432.529-.633a.25.25 0 01.352-.028zm-1.492 1.831a.25.25 0 01.048.35c-.16.212-.323.43-.487.655a.25.25 0 11-.404-.294c.166-.227.33-.448.493-.662a.25.25 0 01.35-.049zm-1.386 1.913a.25.25 0 01.068.347c-.15.222-.3.45-.45.682a.25.25 0 11-.42-.271c.152-.236.304-.466.456-.69a.25.25 0 01.346-.068zm-1.278 1.988a.25.25 0 01.087.342c-.138.231-.275.467-.412.706a.25.25 0 01-.434-.248c.138-.242.277-.48.416-.714a.25.25 0 01.343-.086zm-1.165 2.054a.25.25 0 01.105.338c-.124.238-.248.481-.37.727a.25.25 0 11-.448-.223c.124-.249.25-.494.376-.736a.25.25 0 01.337-.106zm-1.047 2.117a.25.25 0 01.124.331l-.167.375-.164.37a.25.25 0 11-.456-.205l.163-.366.169-.38a.25.25 0 01.33-.125zm-.958 2.108a.25.25 0 01.117.333c-.117.244-.235.485-.353.722a.25.25 0 01-.448-.223c.117-.235.234-.474.35-.715a.25.25 0 01.334-.117zm-1.028 2.056a.25.25 0 01.104.338c-.127.24-.255.476-.382.707a.25.25 0 11-.438-.24c.126-.23.252-.464.378-.702a.25.25 0 01.338-.103zm-1.11 2.015c.12.07.16.223.09.342-.137.235-.274.466-.41.692a.25.25 0 01-.428-.258c.134-.224.27-.453.406-.686a.25.25 0 01.342-.09zm-1.192 1.97a.25.25 0 01.076.345c-.148.231-.294.456-.438.674a.25.25 0 01-.417-.276c.143-.216.288-.438.434-.667a.25.25 0 01.345-.076zm-1.27 1.916a.25.25 0 01.06.348c-.16.228-.316.446-.467.655a.25.25 0 01-.405-.293c.15-.207.305-.423.463-.65a.25.25 0 01.348-.06zm-1.356 1.858a.25.25 0 01.044.35c-.177.23-.344.44-.499.632a.25.25 0 01-.389-.314c.153-.19.318-.398.493-.624a.25.25 0 01.351-.044zm-1.452 1.787a.25.25 0 01.02.353 17.88 17.88 0 01-.253.279l-.014.014-.005.005-.113-.107.113.107a.25.25 0 01-.362-.344L15 36l-.18-.172v-.001l.003-.003.012-.014.05-.053.195-.215a.25.25 0 01.353-.021z"
          fill="#1E3932"
          fillRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0h48v48H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
